import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import throttle from 'lodash.throttle';
import { smooth as SmoothScroll } from '@sainsburys-tech/boltui-utils';
import { ChevronIcon } from '@sainsburys-tech/bolt-icons';
import StyledBackToTop from './BackToTop.styles';

function scrollToTop() {
  SmoothScroll.scrollHere(document.body, 0, 300);
}
/* eslint-disable id-length */


var BackToTop = function BackToTop(_ref) {
  var triggerOffset = _ref.triggerOffset,
      dataTest = _ref['data-test'],
      scrollPosition = _ref.scrollPosition,
      scrollThrottle = _ref.scrollThrottle;

  var _useState = useState({
    y: 0
  }),
      _useState2 = _slicedToArray(_useState, 2),
      position = _useState2[0],
      setPosition = _useState2[1];

  useEffect(function () {
    var getPosition = function getPosition() {
      return {
        y: window.pageYOffset
      };
    };

    if (!scrollPosition) {
      var handleScroll = throttle(function () {
        setPosition(getPosition());
      }, scrollThrottle);
      window.addEventListener('scroll', handleScroll);
      return function () {
        window.removeEventListener('scroll', handleScroll);
      };
    }

    return setPosition(scrollPosition);
  }, []);
  var visible = position.y >= triggerOffset;
  return /*#__PURE__*/React.createElement(StyledBackToTop, {
    onClick: scrollToTop,
    tabIndex: "0",
    visible: visible,
    "data-test": dataTest
  }, /*#__PURE__*/React.createElement(ChevronIcon, {
    height: "24",
    width: "24",
    dir: "up"
  }));
};

BackToTop.propTypes = {
  /**
   * Send in your own scrollPosition object: { x: 0, y: Number }
   */
  scrollPosition: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number
  }),

  /**
   * Specify the offset value when your 'Back To Top' appears
   */
  triggerOffset: PropTypes.number,

  /**
   * Specify the throttle value for your back to top speed
   */
  scrollThrottle: PropTypes.number,

  /**
   * Specify an optional data-test attribute to be added to your 'Back To Top' for e2e testing
   */
  'data-test': PropTypes.string
};
BackToTop.defaultProps = {
  triggerOffset: 600,
  'data-test': 'component-back-to-top'
};
export default BackToTop;